export default class ParameterLayerViewModel {
  constructor() {
    this.id = '';
    this.level_type = '';
    this.level = '';
    this.pnames = [];
    this.parameters = [];
    this.up_time = new Date();
    this.checked = false;
  }

  get checked() {
    if (this.parameters.length) {
      return !this.parameters.some(x => !x.checked);
    }

    return false;
  }

  set checked(value) {
    this.parameters.forEach(x => x.checked = value);
  }

  map(parameterLayer) {
    this.id = parameterLayer.id;
    this.level_type = parameterLayer.level_type;
    this.level = parameterLayer.level;
    this.pnames = parameterLayer.pnames;
    this.up_time = parameterLayer.up_time;

    return this;
  }
}
